import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  TABS: `${cleanedFilename(__filename)}-tabs`,
  NO_FLOWS_CTA: `${cleanedFilename(__filename)}-no-flows-cta`,
  CARD_HEADER: `${cleanedFilename(__filename)}-card-header`,
};
